import { render, staticRenderFns } from "./SignaturesTab.vue?vue&type=template&id=456465f1"
import script from "./SignaturesTab.vue?vue&type=script&lang=js"
export * from "./SignaturesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports